module.exports = __webpack_public_path__ + "img/download01.9867de55.png";